import React from 'react';

import Link from '@atlaskit/link';
import { Box, Text } from '@atlaskit/primitives/compiled';
import { Card as SmartCard } from '@atlaskit/smart-card';
import { type Appendices } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

export type AppendicesViewProps = {
	appendices: Appendices;
	onClickAppendix?: (type: string) => void;
};

const fallbackComponent = (
	url: string,
	type: string,
	title?: string,
	onClickAppendix?: (type: string) => void,
) => {
	const FallbackComponent = () => (
		<Link
			href={url}
			target="_blank"
			rel="noopener noreferrer"
			onClick={() => {
				if (onClickAppendix) {
					onClickAppendix(type);
				}
			}}
		>
			{title || url}
		</Link>
	);
	return FallbackComponent;
};

export const AppendicesView = ({
	appendices,
	onClickAppendix,
}: AppendicesViewProps): React.JSX.Element => {
	return (
		<React.Fragment>
			{appendices.map(({ content, appendix_sources }, index) => (
				<React.Fragment key={index}>
					{!!content && (
						<Box paddingBlockEnd="space.150">
							<Text as="p">{content}</Text>
						</Box>
					)}
					{appendix_sources &&
						appendix_sources.map(
							({ url, title, type }, index) =>
								!!url && (
									<Text as="p" key={index}>
										<SmartCard
											appearance="inline"
											url={url}
											onClick={(e) => {
												if (onClickAppendix) {
													onClickAppendix(type);
												}
												e.preventDefault();
												window.open(url, '_blank', 'noopener, noreferrer');
											}}
											fallbackComponent={fallbackComponent(url, type, title, onClickAppendix)}
										/>
									</Text>
								),
						)}
				</React.Fragment>
			))}
		</React.Fragment>
	);
};
